__turbopack_context__.v({
  "className": "space_grotesk_81e3057-module__PcZKXa__className",
  "variable": "space_grotesk_81e3057-module__PcZKXa__variable",
});
